export default {
    messages: {
        en: {
            compareScene: 'Scene',
            result: 'Status',
            PASS: 'Passing',
            PAYMENT: 'Payment',
            ATTENDANCE: 'Attendance',
            identifyResult: "Identify Result",
            recognitionMethod: 'Recognition Method',
            commentList: 'Comment',
            capturedPicture: "Captured Picture",
            libraryPicture: 'Library Picture',
            confidence: 'Confidence',
            exportExcel: "Excel",
            allInformation: 'All Information',
            correctIdentification: 'Correct Identification',
            identificationErro: 'Identification Erro',
            blank: 'Blank',
            face: 'Face',
            card: 'Card',
            faceAndCard: "Face+Card",
            confirmMatched: 'Confirm matched',
            confirmUnmatched: 'Confirm unmatched',
            parkingdDuration: 'Parking Duration'
        },
        zh: {
            compareScene: '比对场景',
            result: '比对结果',
            PASS: '通行',
            PAYMENT: '支付',
            ATTENDANCE: '考勤',
            identifyResult: '识别结果',
            recognitionMethod: '识别方式',
            commentList: '备注',
            capturedPicture: '抓拍图片',
            libraryPicture: '人像库图片',
            confidence: '置信度',
            exportExcel: "导出Excel",
            allInformation: '导出全部信息',
            correctIdentification: '识别正确',
            identificationErro: '识别错误',
            blank: "空白",
            face: '人脸',
            card: '刷卡',
            faceAndCard: "人脸+刷卡",
            confirmMatched: '识别正确',
            confirmUnmatched: '识别错误',
            parkingdDuration: "停车时长"
        }
    }
};
